import React from "react";
import NewPasswordForm from "../../components/Form/NewPasswordForm/NewPasswordForm";

const NewPasswordPage: React.FC = () => {
  return <NewPasswordForm />;
};

export default NewPasswordPage;
